import { Box, Flex } from "rebass/styled-components";
import Hero from "../Hero";
import Button from "../common/Button";
import Heading from "../common/Heading";
import { heroLandingStyles as styles } from "../../lib/styles/landingStyles";

interface Props {
  isMobileViewport: boolean;
  imgsrc: string;
  imgAlt?: string;
  title: string;
  button?: { text: string; onSubmit: () => void };
  width?: { mobile: string; nonMobile: string | string[] };
  height?: string | string[];
}

function HeroLanding(props: Props) {
  const {
    isMobileViewport,
    imgsrc,
    imgAlt,
    title,
    button,
    width = { mobile: "100%", nonMobile: "100%" },
    height = ["400px", "400px", "775px"]
  } = props;

  const deviceStyle = isMobileViewport ? styles.mobile : styles.nonMobile;
  const widthDevice = isMobileViewport ? width.mobile : width.nonMobile;

  return (
    <Hero variant="landing" imgsrc={imgsrc} imgAlt={imgAlt} height={height}>
      <Flex sx={deviceStyle.flex}>
        <Heading as="h1" sx={{ ...deviceStyle.text, width: widthDevice }}>
          {title}
        </Heading>
        {button && (
          <Box sx={styles.boxButton}>
            <Button
              variant="primary"
              sx={styles.button}
              onClick={button.onSubmit}
            >
              {button.text}
            </Button>
          </Box>
        )}
      </Flex>
    </Hero>
  );
}

export default HeroLanding;
